<template>
    <div class="account">
        <div class="action-header">
            <div class="action-header__title">
                {{title}}
            </div>
            <div class="action-header__date-picker">
                <vue-date-picker :disabled-date="(date) => date >= disabledAfter" range-separator=" " :formatter="customFormat" v-model="time" :shortcuts="shortcuts" range format="DD/MM/YYYY"></vue-date-picker>
            </div>
        </div>
        <div class="account__actions actions">
            <div class="actions__search-container">
                <input @input="applySearch" class="actions__search-input" type="text" v-model="filter.query" placeholder="Search by IP"/>
                <inline-svg
                    class="actions__search-icon"
                    src="/images/search.svg" aria-label="search">
                </inline-svg>
                <inline-svg
                    v-show="filter.query"
                    @click="clearSearch()"
                    class="clear-search"
                    src="/images/clear.svg" aria-label="clear">
                </inline-svg>
            </div>
            <div class="actions__add-filter__wrapper" @click.capture="onLoadFilterData">
                <data-filter @filterApply='applyFilter' v-bind:customLabels="{detected: {'true': 'Blocked', 'false': 'Valid'}}" v-bind:filtersInit="filtersDataComponent" v-bind:isLoadingFilter="isLoadingFilter"></data-filter>
            </div>
            <div @click="onDownloadExcelClick" class="download-to-excel" data-toggle="tooltip" data-placement="left" title="Download to Excel">
                <inline-svg
                    src="/images/icons/file_download.svg" aria-label="download">
                </inline-svg>
            </div>
        </div>

        <div class="account__table main-table">
            <table class="main-table__wrapper">
                <thead class="main-table__header">
                    <th class="main-table__header-item">
                        <span id="created_at" @click="sortTable($event, 'created_at', 'ASC')" class="table-header-sort noselect">
                            <span>
                                Clicked on
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span @click="sortTable($event, 'block_reason_id', 'ASC')" class="table-header-sort noselect">
                            <span>
                                Status
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span @click="sortTable($event, 'device', 'ASC')" class="table-header-sort noselect">
                            <span>
                                Device
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span @click="sortTable($event, 'ip', 'ASC')" class="table-header-sort noselect">
                            <span>
                                IP
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span @click="sortTable($event, 'os', 'ASC')" class="table-header-sort noselect">
                            <span>
                                OS
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span @click="sortTable($event, 'browser', 'ASC')" class="table-header-sort noselect">
                            <span>
                                Browser
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span @click="sortTable($event, 'account_name', 'ASC')" class="table-header-sort noselect">
                            <span>
                                Google Ads Account
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                    <th class="main-table__header-item">
                        <span @click="sortTable($event, 'campaign_name', 'ASC')" class="table-header-sort noselect">
                            <span>
                                Campaign
                            </span>
                            <span class="sort-col-wrapper">
                                <inline-svg
                                    class="sort-icon sort-icon-desc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                                <inline-svg
                                    class="sort-icon sort-icon-down sort-icon-asc"
                                    src="/images/up-arrow.svg" aria-label="PPCShield">
                                </inline-svg>
                            </span>
                        </span>
                    </th>
                </thead>
                <tbody class="main-table__body">
                    <template v-if="isLoading" >
                        <tr class="main-table__row-container">
                            <td class="main-table__row-item" colspan="8">
                                <div class="loader">
                                    <svg class="circular" viewBox="25 25 50 50">
                                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                                    </svg>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else-if="tableData && tableData.length">
                        <tr v-for="item in tableData" class="main-table__row-container">
                            <td class="main-table__row-item not-pointer-column">
                                {{ item.created_at }}
                            </td>
                            <td class="main-table__row-item not-pointer-column">
                                <div v-if="item.is_banned" class="svg-box" data-toggle="tooltip" data-placement="bottom" title="Blocked">
                                    <inline-svg
                                        class="main-table__check-icon fail s-28"
                                        src="/images/icons/gpp_bad_black_24dp.svg" aria-label="banned">
                                    </inline-svg>
                                </div>
                                <div v-else data-toggle="tooltip" class="svg-box" data-placement="bottom" title="Valid">
                                    <inline-svg
                                        class="main-table__check-icon success s-28"
                                        src="/images/icons/gpp_good_black_24dp.svg" aria-label="not banned">
                                    </inline-svg>
                                </div>
                            </td>
                            <td class="main-table__row-item not-pointer-column">
                                <show-device :device="item.device" :tooltip="true"></show-device>
                            </td>
                            <td class="main-table__row-item not-pointer-column">
                                <img v-if="item.country_code"
                                     class="country-flag"
                                     :src="'http://purecatamphetamine.github.io/country-flag-icons/3x2/'+item.country_code+'.svg'" alt="country flag"
                                     data-toggle="tooltip" data-placement="bottom" :title="item.country_name">
                                <span v-else
                                      class="empty-country-flag"
                                      data-toggle="tooltip" data-placement="bottom" title="Unavailable"></span>
                                <span style="margin-left: 5px;">{{ item.ip }}</span>
                            </td>
                            <td class="main-table__row-item not-pointer-column">
                                <show-os :os="item.os"></show-os>
                            </td>
                            <td class="main-table__row-item not-pointer-column">
                                {{item.browser}}
                            </td>
                            <td class="main-table__row-item not-pointer-column">
                                {{ item.account_name }}
                            </td>
                            <td class="main-table__row-item not-pointer-column">
                                {{ item.campaign_name }}
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr class="main-table__row-container">
                            <td class="main-table__row-item" colspan="8">Not found</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="pagination-container">
            <span v-if="pages" class="mr-5">Show rows {{page * 20 - 19}} - {{page == pages ? pages_rows : page * 20}} of {{pages_rows}}</span>
            <paginate v-if="pages"
                      :v-model="page"
                      :page-count="pages"
                      :click-handler="getPage"
                      :prev-text="'Prev'"
                      :next-text="'Next'"
                      :container-class="'pagination mb-0'"
                      :page-class="'page-item'">
            </paginate>
        </div>

        <modal :height="'auto'" :width="'400px'" name="wait-download-modal" :clickToClose="false">
            <div class="informative-modal flex flex-col">
                <div class="header">

                </div>
                <div class="body">
                    <div class="loader mb-3">
                        <svg class="circular" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                        </svg>
                    </div>
                    Processing your file. Please wait a few moments.
                </div>
                <div class="footer flex justify-end space-x-2">

                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="'400px'" name="background-download-modal" :clickToClose="false">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Background Export Report
                </div>
                <div class="body">
                    You have over 10,000 records in your report based on the applied filters. We run large reports in the background so you can continue working in PPC Shield without having to wait for them to download. When the file is ready, you will receive an email with a link to download it.
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="$modal.hide('background-download-modal')">Close</button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="'400px'" name="error-too-large-modal" :clickToClose="false">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    File is too large
                </div>
                <div class="body">
                    You have over 100,000 rows in your report based on the applied filters and date range. You can export only up to 100,000 rows. Please try to reduce the date range or apply some filter.
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="$modal.hide('error-too-large-modal')">Close</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import {clicksTable, clicksTableTitles} from '../../helpers/clicks-table';
import Paginate from 'vuejs-paginate';
import {dateShortCuts, defaultDateRange, setCookiesDateRange, dateToString, stringToDate} from "../../helpers/date-converter";

export default {
    name: 'clicks',
    props: ['campaign_id', 'title'],
    components: {
        Paginate
    },
    data: function () {
        return {
            isLoading: false,
            tableTitles: clicksTableTitles(),
            tableData: null,
            pages_rows: null,
            pages: null,
            page: 1,
            filter: {
                query: '',
                page: 1,
                tags: {},
                campaign_id: 'null',
                sort: {
                    'column': '',
                    'sort': '',
                }
            },
            time: defaultDateRange(),
            shortcuts: dateShortCuts(),
            filtersDataComponent: null,
            disabledAfter: this.$moment(moment().add(1, 'day').format("DD-MM-YYYY"), "DD-MM-YYYY"),
            crutch_for_date_picker: false,
            isLoadingFilter: false,
        }
    },
    computed: {
        customFormat() {
            return {
                stringify: (date) => {
                    if(moment(this.time[1]).format('L') === moment(this.time[0]).format('L')){
                        if(!this.crutch_for_date_picker){
                            this.crutch_for_date_picker = true;
                        }
                        else  {
                            this.crutch_for_date_picker = false;
                        }
                        return date
                            ? this.crutch_for_date_picker
                                ? moment(date).format('L') === moment(this.time[0]).format('L')
                                    ? dateToString(moment(this.time[0]).format('MMM D YYYY'), moment(this.time[1]).format('MMM D YYYY'))
                                    : ''
                                : ''
                            : ''
                    }
                    else{
                        return date
                            ? moment(date).format('L') === moment(this.time[0]).format('L')
                                ? dateToString(moment(this.time[0]).format('MMM D YYYY'), moment(this.time[1]).format('MMM D YYYY'))
                                : ''
                            : ''
                    }
                },
                parse: (value) => {
                    return value
                        ? this.calcDateFormatToDate()
                        : null
                },
            }
        },
    },
    methods: {
        onDownloadExcelClick(){
            if(this.isLoading || !this.pages_rows) return;
            if(this.pages_rows > 100000){
                this.$modal.show('error-too-large-modal');
                return;
            }

            const date_from = this.time[0] ? moment(this.time[0]).format('DD-MM-YYYY') : '';
            const date_to = this.time[1] ? moment(this.time[1]).format('DD-MM-YYYY') : '';
            if(this.pages_rows < 10000){
                this.$modal.show('wait-download-modal');

                axios.get('/download/excelReport?query=' + this.filter.query
                    + '&column=' + this.filter.sort.column
                    + '&type=' + this.filter.sort.type
                    + '&filters=' + JSON.stringify(this.filter.tags)
                    + '&date_from=' + date_from
                    + '&date_to=' + date_to
                    + '&campaign_id=' + this.filter.campaign_id
                    + '&excelFor=click'
                )
                    .then(info => {
                        this.$modal.hide('wait-download-modal');
                        console.log(info.data.download_url);
                        const a = document.createElement("a");
                        a.href =  info.data.download_url;
                        a.setAttribute("download", 'file');
                        a.click();
                    })
                    .catch(err => {
                        console.log('err', err);
                        this.$modal.hide('wait-download-modal');
                    });
            }
            else{
                axios.get('/download/excelReport?query=' + this.filter.query
                    + '&column=' + this.filter.sort.column
                    + '&type=' + this.filter.sort.type
                    + '&filters=' + JSON.stringify(this.filter.tags)
                    + '&date_from=' + date_from
                    + '&date_to=' + date_to
                    + '&campaign_id=' + this.filter.campaign_id
                    + '&excelFor=click'
                    + '&task=' + 'true'
                )
                    .then(info => {
                        this.$modal.show('background-download-modal');
                    })
                    .catch(err => {
                        console.log('err', err);
                        this.$modal.show('background-download-modal');
                    });
            }
        },
        onLoadFilterData(){
            if(this.isLoadingFilter || this.filtersDataComponent) return;
            this.getFiltersData();
        },
        calcDateFormatToDate(){
            let stringDate = $('.action-header__date-picker .mx-input-wrapper input').val();
            let tempTime = stringToDate(stringDate);
            if(tempTime[0].isValid() &&
                tempTime[1].isValid() &&
                (moment(this.time[0]).format('MMM D YYYY') !== moment(tempTime[0]).format('MMM D YYYY') ||
                    moment(this.time[1]).format('MMM D YYYY') !== moment(tempTime[1]).format('MMM D YYYY')))
            {
                this.time = [tempTime[0].toDate(), tempTime[1].toDate()];
                this.getChartData();
            }
            return null;
        },
        sortTable(event, column, type) {
            $(".sort-icon").removeClass("active-sort");
            let element = $(event.currentTarget);
            if(column === this.filter.sort.column) {
                if(this.filter.sort.type === 'ASC') {
                    type = 'DESC';
                    $(element).find(".sort-icon-asc").addClass("active-sort");
                }
                /*else if(this.filter.sort.type === 'DESC') {
                    type = '';
                }*/
                else {
                    type = 'ASC';
                    $(element).find(".sort-icon-desc").addClass("active-sort");
                }
            } else {
                $(element).find(".sort-icon-desc").addClass("active-sort");
            }
            this.filter.sort.column = column;
            if(type === '') this.filter.sort.column = '';
            this.filter.sort.type = type;
            this.getClicksData();
        },
        clearSearch() {
            this.filter.query = '';
            this.getClicksData();
        },
        getClicksData() {
            const last_search_value = this.filter.query;
            if(this.isLoading) return;
            this.isLoading = true;
            this.filter.campaign_id = this.campaign_id;
            axios.get('clicks/total', {
                params: {
                    query: this.filter.query,
                    page: this.filter.page,
                    campaign_id: this.filter.campaign_id,
                    column: this.filter.sort.column,
                    type: this.filter.sort.type,
                    date_from: this.time[0] ? moment(this.time[0]).format() : '',
                    date_to: this.time[1] ? moment(this.time[1]).format() : '',
                    //timezone: new Date().getTimezoneOffset(),
                    filters: this.filter.tags
                }
            })
            .then(info => {
                this.isLoading = false;
                if(last_search_value === this.filter.query){
                    const {data: {items = []}} = info;
                    this.tableData = clicksTable(items);
                    this.pages_rows = info.data.total_rows;
                    this.pages = info.data.total;
                    setTimeout(() => {
                        $(function () {
                            $('[data-toggle="tooltip"]').tooltip()
                        })
                    },0);
                }
                else{
                    this.getClicksData();
                }
            })
            .catch(err => {
                this.isLoading = false;
                console.log('err', err);
            });
        },
        getFiltersData() {
            this.isLoadingFilter = true;
            axios.get('clicks/totalled', {
                params: {campaign_id: this.filter.campaign_id}
            })
                .then(info => {
                    this.filtersDataComponent = info.data.items;
                    this.isLoadingFilter = false;
                })
                .catch(err => {
                    console.log('err', err);
                    this.isLoadingFilter = false;
                });
        },
        applySearch() {
            this.page = 1;
            this.filter.page = 1;
            this.getClicksData();
        },
        applyFilter(data) {
            this.filter.tags = data.filter_data;
            this.page = 1;
            this.filter.page = 1;
            this.getClicksData();
        },
        getPage: function (pageNum) {
            this.page = pageNum;
            this.filter.page = pageNum;
            this.getClicksData()
        },
        setAllTimeDatePicker(){
            axios.get('/account/getStartAllTimeDate')
                .then(response => {
                    this.shortcuts = dateShortCuts(response.data);
                });
        },
    },
    mounted() {
        this.setAllTimeDatePicker();

        setTimeout(() => {$('#created_at').find(".sort-icon-asc").addClass("active-sort");}, 200);
        this.filter.sort.column = 'created_at';
        this.filter.sort.type = 'DESC';
        this.getClicksData();
    },
    watch: {
        time: function(val) {
            setCookiesDateRange(val[0], val[1]);
            this.getClicksData();
        }
    }
}
</script>
